<div mat-dialog-content class="form-container" >
    <form class="form__pagoInvitacion" [formGroup]="metodoPago">
        <h1>Pago de Nuevas Licencias</h1>
        <div class="infoPago">
            <p>A continuación se inicia el proceso del pago de la(s) licencia(s) seleccionada(s).</p>
            <p>El precio de cada licencia es de <span class="precio">{{precioLicencia}}€ </span> (base imponible).</p>
            <h2>El precio Total a pagar por la(s) licencia(s) es de: <span class="precio">{{totalFront}}€</span> (IVA incluido). </h2>
        </div> 
        <h3>Seleccione el método de pago:</h3>
                  <div class="metodoPago">
                    <div class="radioButton">
                      <div class="metodo-check">
                        <img src="./../../../../assets/tarjeta-de-credito.png" alt="">
                        <input
                          type="radio"
                          value="tarjeta"
                          id="tarjeta"
                          formControlName="pago"
                          (change)="setTipoPago($event)"
                          
                        />
                        <label for="tarjeta"> Tarjeta de Crédito</label>
                      </div>
                      <!-- <div class="metodo-check">
                       <img src="./../../../../assets/transferencia.png" alt="">
                        <input
                          type="radio"
                          value="transferencia"
                          id="transferencia"
                          formControlName="pago"
                          (change)="setTipoPago($event)"
                        />
                        <label for="transferencia"> Transferencia Bancaria</label>
                      </div> -->
                    </div>
                  </div>
                  <div class="privacidad">
                    <input type="checkbox" id="privacidad" formControlName="policy" (change)="setPolicy($event)"/>
                   <label for="privacidad" id="privacidad"> He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a> y las <a href="https://xtensa.es/condiciones-de-compra/"  target="_blank">Condiciones de Compra</a></label><br><br>
                   <p id="proteccion-invitacion">El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL.<br> La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros.<br>Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
                  </div>
                  
    </form>
    
      <button class="btn-tpv1" *ngIf="button" #buttonContainer></button>
    
</div>
